
import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
  loading: false,
}

export default function userReducer(state = initialState, action) {
  // console.log('userReducer', state, action)
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SET_TALENT_CREDITS:
      return { ...state, settings: {...state.settings, talentSponsoredCredits: action.payload.credits } }
    default:
      return state
  }
}
